import type { AppRoute } from "./types";
import { dashboardCasesClientRoutes } from "./routeGroups/part01DashboardCasesClients";
import { rolesAlertsBusinessAuthRoutes } from "./routeGroups/part02RolesAlertsBusinessAuth";
import { signupLegacyRedirectRoutes } from "./routeGroups/part03SignupLegacyRedirects";
import { paymentsGroupsAdminRoutes } from "./routeGroups/part04PaymentsGroupsAdmin";
import { usersTagsFeedbackRoutes } from "./routeGroups/part05UsersTagsFeedback";
import { reportsCategoriesProfileChatRoutes } from "./routeGroups/part06ReportsCategoriesProfile";

const routes: AppRoute[] = [
  ...dashboardCasesClientRoutes,
  ...rolesAlertsBusinessAuthRoutes,
  ...signupLegacyRedirectRoutes,
  ...paymentsGroupsAdminRoutes,
  ...usersTagsFeedbackRoutes,
  ...reportsCategoriesProfileChatRoutes,
];

export default routes;
